/* eslint-disable semi */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import Layout from "@/layout";

const systemMenu = {
  path: "/system",
  component: Layout,
  alwaysShow: true,
  redirect: "/system/manage",
  meta: {
    title: "시스템 관리",
    icon: "twoCogwheel",
  },
  children: [
    {
      path: "admin",
      component: () => import("@/views/management/AdminManage.vue"),
      name: "adminSetting",
      meta: {
        title: "관리자 관리",
      },
    },
    // {
    //   path: "userMemberSetting",
    //   component: () => import("@/views/management/UserManage.vue"),
    //   name: "userMemberSetting",
    //   meta: {
    //     title: "사용자 관리",
    //   },
    // },
    {
      path: "virtualBankSetting",
      component: () =>
        import("@/views/system/virtualBank/VirtualBankMainManage.vue"),
      name: "virtualBankSetting",
      meta: {
        title: "가상계좌관리",
      },
    },
    {
      path: "discountUnpaid",
      component: () =>
        import(
          "@/views/system/discountList/DiscountListUnpaidSettingManage.vue"
        ),
      name: "discountUnpaid",
      meta: {
        title: "미납 할인항목",
      },
    },
    // {
    //   path: "discountListSetting",
    //   component: () => import("@/views/system/discountList/index.vue"),
    //   name: "discountListSetting",
    //   meta: {
    //     title: "할인항목관리",
    //   },
    //   children: [
    //     {
    //       path: "discountSeason",
    //       component: () =>
    //         import("@/views/system/discountList/DiscountListSettingManage.vue"),
    //       name: "discountSeason",
    //       meta: {
    //         title: "정기권 할인항목",
    //       },
    //     },
    //     {
    //       path: "discountUnpaid",
    //       component: () =>
    //         import(
    //           "@/views/system/discountList/DiscountListUnpaidSettingManage.vue"
    //         ),
    //       name: "discountUnpaid",
    //       meta: {
    //         title: "미납 할인항목",
    //       },
    //     },
    //   ],
    // },

    {
      path: "addAdmin",
      component: () => import("@/views/management/template/AdminAddManage.vue"),
      name: "adminAddSetting",
    },
    {
      path: "rewriteAdmin",
      component: () =>
        import("@/views/management/template/AdminRewriteManage.vue"),
      name: "adminRewriteSetting",
    },
    {
      path: "addUser",
      component: () =>
        import("@/views/management/template/user/UserAddManage.vue"),
      name: "userAddSetting",
    },
    {
      path: "rewriteUser",
      component: () =>
        import("@/views/management/template/user/UserRewrtieManage.vue"),
      name: "rewriteUser",
    },
  ],
};

export default systemMenu;
